import {URL} from 'components/Fields';

const Http = () => <URL />;

export default Http;
